function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

class SectionId {
  static #separator = '__';

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section id (e.g. 'template--22224696705326')
  static parseId(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[0];
  }

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section name (e.g. 'main')
  static parseSectionName(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[1];
  }

  // for a section id (e.g. 'template--22224696705326') and a section name (e.g. 'recommended-products'), return a qualified section id (e.g. 'template--22224696705326__recommended-products')
  static getIdForSection(sectionId, sectionName) {
    return `${sectionId}${SectionId.#separator}${sectionName}`;
  }
}

class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement('div');
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll('[id], [form]').forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = 'none';

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll('script').forEach((oldScriptTag) => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}
// ---------------- Start: Custom Js For Collapsible Row ------------------
document.addEventListener('DOMContentLoaded', function () {
  const allAccordions = document.querySelectorAll('.accordion-item');
  let activeImage = null;

  function switchImage(newImage) {
    const currentImage = activeImage;


    
    if (currentImage) {
      currentImage.classList.add('fading-out'); 
      currentImage.addEventListener('animationend', function collapseHandler(event) {
        if (event.animationName !== 'fade-out') return;

        currentImage.classList.remove('fading-out');
        currentImage.style.display = 'none';
        currentImage.removeEventListener('animationend', collapseHandler);

        activeImage = newImage;
        activeImage.style.display = 'block';
        activeImage.classList.add('sliding-down');
        
        activeImage.addEventListener('animationend', function expandHandler(e) {
          if (e.animationName !== 'slide-down') return;
          activeImage.classList.remove('sliding-down');
          activeImage.removeEventListener('animationend', expandHandler);
        });
      });
    } else {
      // This is the case for the very first image
      activeImage = newImage;
      activeImage.style.display = 'block';
      activeImage.classList.add('sliding-down');
      activeImage.addEventListener('animationend', function expandHandler(e) {
        if (e.animationName !== 'slide-down') return;
        activeImage.classList.remove('sliding-down');
        activeImage.removeEventListener('animationend', expandHandler);
      });
    }
  }

  allAccordions.forEach((accordion) => {
    const summary = accordion.querySelector('summary');
    summary.addEventListener('click', function (e) {
      e.preventDefault();
      const isOpen = accordion.hasAttribute('open');
      if (!isOpen) {
        allAccordions.forEach(item => item.removeAttribute('open'));
        accordion.setAttribute('open', '');
        const id = accordion.getAttribute('id').replace('Details-', '');
        const targetImage = document.getElementById('Image-' + id);
        if (targetImage && targetImage !== activeImage) {
          switchImage(targetImage);
        }
      }
    });
  });

  const firstAccordion = document.querySelector('.accordion-item');
  if (firstAccordion) {
    firstAccordion.setAttribute('open', '');
    const id = firstAccordion.getAttribute('id').replace('Details-', '');
    const firstImage = document.getElementById('Image-' + id);
    if (firstImage) {
        activeImage = firstImage;
        firstImage.style.display = 'block';
    }
  }
});
// ---------------- End: Custom Js For Collapsible Row ----------------------

// ---------------- Start: View all Button ----------------------
// document.addEventListener('DOMContentLoaded', function() {
//   document.querySelectorAll('.view-all-btn').forEach(btn => {
//     btn.addEventListener('click', function() {
//       const { sectionId, type: buttonType, desktopLimit, mobileLimit } = this.dataset;
//       const grid = document.querySelector(`#grid-${sectionId}`);
//       if (!grid) return;
//       // Select products to show based on button type
//       const selector = buttonType === 'desktop' 
//         ? '.initially-hidden-desktop, .initially-hidden-both'
//         : '.initially-hidden-mobile, .initially-hidden-both';
//       // Show products with staggered animation
//       grid.querySelectorAll(selector).forEach((product, i) => {
//         setTimeout(() => {
//           product.className = product.className
//             .replace(/initially-hidden-\w+|hide-on-\w+/g, '') + ' fade-in';
//           product.style.display = 'block';
//         }, i * 100);
//       });
//       // Hide button after animation
//       const btnClass = buttonType === 'desktop' ? 'desktop-view-all' : 'mobile-view-all';
//       const wrapper = document.querySelector(`.view_button_wrapper-${buttonType === 'mobile' ? 'mobile-' : ''}${sectionId}.${btnClass}`);
//       setTimeout(() => wrapper?.style.setProperty('display', 'none'), 500);
//     });
//   });
//   // Handle responsive behavior on resize
//   let resizeTimeout;
//   window.addEventListener('resize', () => {
//     clearTimeout(resizeTimeout);
//     resizeTimeout = setTimeout(() => {
//       const isMobile = innerWidth <= 768;
//       document.querySelectorAll('.qft-grid-box').forEach(product => {
//         const { productIndex, mobileLimit, desktopLimit } = product.dataset;
//         const limit = isMobile ? +mobileLimit : +desktopLimit;
//         const shouldHide = +productIndex > limit && !product.classList.contains('fade-in');
//         product.style.display = shouldHide ? 'none' : 'block';
//       });
//     }, 250);
//   });
// });
// ---------------- End: View all Button ----------------------

document.querySelectorAll('[id^="Details-"]').forEach((details) => {
  details.addEventListener('toggle', () => {
    if (details.open) {
      // Close all other accordions
      document.querySelectorAll('[id^="Details-"]').forEach((other) => {
        if (other !== details) {
          other.removeAttribute('open');
          const summary = other.querySelector('summary');
          if (summary) summary.setAttribute('aria-expanded', false);
        }
      });

      // Update aria-expanded for the active one
      const summary = details.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', true);
    }
  });
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.target.name === 'plus') {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class BulkModal extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      if (this.innerHTML.trim() === '') {
        const productUrl = this.dataset.url.split('?')[0];
        fetch(`${productUrl}?section_id=bulk-quick-order-list`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const sourceQty = html.querySelector('.quick-order-list-container').parentNode;
            this.innerHTML = sourceQty.innerHTML;
          })
          .catch((e) => {
            console.error(e);
          });
      }
    };

    new IntersectionObserver(handleIntersection.bind(this)).observe(
      document.querySelector(`#QuickBulk-${this.dataset.productId}-${this.dataset.sectionId}`)
    );
  }
}

customElements.define('bulk-modal', BulkModal);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

// class SliderComponent extends HTMLElement {
//   constructor() {
//     super();
//     this.slider = this.querySelector('[id^="Slider-"]');
//     this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
//     this.enableSliderLooping = false;
//     this.currentPageElement = this.querySelector('.slider-counter--current');
//     this.pageTotalElement = this.querySelector('.slider-counter--total');
//     this.prevButton = this.querySelector('button[name="previous"]');
//     this.nextButton = this.querySelector('button[name="next"]');
//     if (!this.slider || !this.nextButton) return;
//     this.initPages();
//     const resizeObserver = new ResizeObserver((entries) => this.initPages());
//     resizeObserver.observe(this.slider);
//     this.slider.addEventListener('scroll', this.update.bind(this));
//     this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
//     this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
//   }

//   initPages() {
//     this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
//     if (this.sliderItemsToShow.length < 2) return;
//     this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
//     this.slidesPerPage = Math.floor(
//       (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
//     );
//     this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
//     this.update();
//   }

//   resetPages() {
//     this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
//     this.initPages();
//   }

//   update() {
//     if (!this.slider || !this.nextButton) return;
//     const previousPage = this.currentPage;
//     this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;
//     this.querySelectorAll(`.slider-counter > .dots`).forEach((el,i)=>{
//       if (i === this.currentPage - 1) {
//         el.classList.add('active');
//       } else {
//         el.classList.remove('active');
//       }
//       el.classList.remove('dots-prev');
//       el.classList.remove('dots-next');
//     });
//     if(this.querySelector('.dots.active').previousElementSibling)
//     this.querySelector('.dots.active').previousElementSibling.classList.add('dots-prev');
//     if(this.querySelector('.dots.active').nextElementSibling)
//     this.querySelector('.dots.active').nextElementSibling.classList.add('dots-next');
//     if (this.currentPageElement && this.pageTotalElement) {
//       this.currentPageElement.textContent = this.currentPage;
//       this.pageTotalElement.textContent = this.totalPages;
//     }
//     if (this.currentPage != previousPage) {
//       this.dispatchEvent(
//         new CustomEvent('slideChanged', {
//           detail: {
//             currentPage: this.currentPage,
//             currentElement: this.sliderItemsToShow[this.currentPage - 1],
//           },
//         })
//       );
//     }
//     if (this.enableSliderLooping) return;
//     if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
//       this.prevButton.setAttribute('disabled', 'disabled');
//     } else {
//       this.prevButton.removeAttribute('disabled');
//     }
//     if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
//       this.nextButton.setAttribute('disabled', 'disabled');
//     } else {
//       this.nextButton.removeAttribute('disabled');
//     }
//   }

//   isSlideVisible(element, offset = 0) {
//     const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
//     return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
//   }

//   onButtonClick(event) {
//     event.preventDefault();
//     const step = event.currentTarget.dataset.step || 1;
//     this.slideScrollPosition =
//       event.currentTarget.name === 'next'
//         ? this.slider.scrollLeft + step * this.sliderItemOffset
//         : this.slider.scrollLeft - step * this.sliderItemOffset;
//     this.setSlidePosition(this.slideScrollPosition);
//   }

//   setSlidePosition(position) {
//     this.slider.scrollTo({
//       left: position,
//     });
//   }
// }
// customElements.define('slider-component', SliderComponent);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    // Initialize currentPage
    this.currentPage = 1;
    if (!this.slider) return;
    // Wait for DOM to be ready
    requestAnimationFrame(() => {
      this.initPages();
    });
    
    const resizeObserver = new ResizeObserver(() => this.initPages());
    resizeObserver.observe(this.slider);
    // Use both scroll and scrollend events for better responsiveness
    this.slider.addEventListener('scroll', this.onScroll.bind(this));
    this.slider.addEventListener('scrollend', this.update.bind(this));
    
    if (this.prevButton) {
      this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    }
    if (this.nextButton) {
      this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    }
  }
  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length === 0) return;
    if (this.sliderItemsToShow.length === 1) {
      this.slidesPerPage = 1;
      this.totalPages = 1;
      this.sliderItemOffset = this.slider.clientWidth;
      this.update();
      return;
    }
    // Calculate offset between slides
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    // Fallback if offset calculation fails
    if (this.sliderItemOffset <= 0) {
      this.sliderItemOffset = this.sliderItemsToShow[0].clientWidth;
    }
    this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemOffset) || 1;
    this.totalPages = Math.max(1, this.sliderItemsToShow.length);
    this.update();
  }
  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }
  onScroll() {
    // Throttle scroll updates for performance
    if (this.scrollTimeout) return;
    this.scrollTimeout = setTimeout(() => {
      this.update();
      this.scrollTimeout = null;
    }, 10);
  }
  update() {
    if (!this.slider || this.sliderItemsToShow.length === 0) return;
    const previousPage = this.currentPage;
    // Calculate current page based on which slide is most visible
    this.currentPage = this.getCurrentVisibleSlide();
    // Update dots
    this.updateDots();
    // Dispatch slide change event
    if (this.currentPage !== previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }
    // Update button states
    this.updateButtonStates();
  }
  getCurrentVisibleSlide() {
    const scrollLeft = this.slider.scrollLeft;
    const containerWidth = this.slider.clientWidth;
    const centerPoint = scrollLeft + containerWidth / 2;
    
    let currentSlide = 1;
    let minDistance = Infinity;
    
    this.sliderItemsToShow.forEach((slide, index) => {
      const slideCenter = slide.offsetLeft + slide.clientWidth / 2;
      const distance = Math.abs(centerPoint - slideCenter);
      if (distance < minDistance) {
        minDistance = distance;
        currentSlide = index + 1;
      }
    });
    return Math.max(1, Math.min(currentSlide, this.totalPages));
  }
  updateDots() {
    // Select all dots within the slider-counter
    const dots = this.querySelectorAll('.slider-counter .dots');
    if (dots.length === 0) return;
    dots.forEach((dot, index) => {
      // Remove all state classes
      dot.classList.remove('active', 'dots-prev', 'dots-next');
      // Add active class to current dot
      if (index === this.currentPage - 1) {
        dot.classList.add('active');
      }
    });
    // Add adjacent classes
    const activeDot = this.querySelector('.slider-counter .dots.active');
    if (activeDot) {
      const prevDot = activeDot.previousElementSibling;
      const nextDot = activeDot.nextElementSibling;
      if (prevDot && prevDot.classList.contains('dots')) {
        prevDot.classList.add('dots-prev');
      }
      if (nextDot && nextDot.classList.contains('dots')) {
        nextDot.classList.add('dots-next');
      }
    }
  }
  updateButtonStates() {
    if (this.enableSliderLooping || !this.prevButton || !this.nextButton) return;
    // Update previous button
    if (this.currentPage <= 1) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }
    // Update next button  
    if (this.currentPage >= this.totalPages) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }
  isSlideVisible(element, offset = 0) {
    if (!element) return false;
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }
  onButtonClick(event) {
    event.preventDefault();
    const step = parseInt(event.currentTarget.dataset.step) || 1;    
    let targetPage;
    if (event.currentTarget.name === 'next') {
      targetPage = Math.min(this.currentPage + step, this.totalPages);
    } else {
      targetPage = Math.max(this.currentPage - step, 1);
    }    
    this.goToSlide(targetPage);
  }
  goToSlide(slideNumber) {
    if (slideNumber < 1 || slideNumber > this.totalPages) return;    
    const targetSlide = this.sliderItemsToShow[slideNumber - 1];
    if (!targetSlide) return;    
    const targetPosition = targetSlide.offsetLeft;    
    this.slider.scrollTo({
      left: targetPosition,
      behavior: 'smooth'
    });
  }
  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
      behavior: 'smooth'
    });
  }
}
customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow && this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.sliderItemsToShow ? this.currentPage === this.sliderItemsToShow.length : false;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderItemsToShow ? this.sliderItemsToShow.length : 1);
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    if (!this.sliderItemsToShow) return;
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
      (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}
customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('change', (event) => {
      const target = this.getInputForEventTarget(event.target);
      this.updateSelectionMetadata(event);

      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event,
          target,
          selectedOptionValues: this.selectedOptionValues,
        },
      });
    });
  }

  updateSelectionMetadata({ target }) {
    const { value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      Array.from(target.options)
        .find((option) => option.getAttribute('selected'))
        .removeAttribute('selected');
      target.selectedOptions[0].setAttribute('selected', 'selected');

      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = target
        .closest('.product-form__input')
        .querySelector('[data-selected-value] > .swatch');
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }

      selectedDropdownSwatchValue.style.setProperty(
        '--swatch-focal-point',
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
      );
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  getInputForEventTarget(target) {
    return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
  }

  get selectedOptionValues() {
    return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
      ({ dataset }) => dataset.optionValueId
    );
  }
}
customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
  observer = undefined;

  constructor() {
    super();
  }
  connectedCallback() {
    this.initializeRecommendations(this.dataset.productId);
  }

  initializeRecommendations(productId) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: '0px 0px 400px 0px' }
    );
    this.observer.observe(this);
  }

  loadRecommendations(productId) {
    fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
          this.remove();
        }

        if (html.querySelector('.grid__item')) {
          this.classList.add('product-recommendations--loaded');
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}
customElements.define('product-recommendations', ProductRecommendations);

class AccountIcon extends HTMLElement {
  constructor() {
    super();
    this.icon = this.querySelector('.icon');
  }

  connectedCallback() {
    document.addEventListener('storefront:signincompleted', this.handleStorefrontSignInCompleted.bind(this));
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}
customElements.define('account-icon', AccountIcon);

class BulkAdd extends HTMLElement {
  constructor() {
    super();
    this.queue = [];
    this.requestStarted = false;
    this.ids = [];
  }

  startQueue(id, quantity) {
    this.queue.push({ id, quantity });
    const interval = setInterval(() => {
      if (this.queue.length > 0) {
        if (!this.requestStarted) {
          this.sendRequest(this.queue);
        }
      } else {
        clearInterval(interval);
      }
    }, 250);
  }

  sendRequest(queue) {
    this.requestStarted = true;
    const items = {};
    queue.forEach((queueItem) => {
      items[parseInt(queueItem.id)] = queueItem.quantity;
    });
    this.queue = this.queue.filter((queueElement) => !queue.includes(queueElement));
    const quickBulkElement = this.closest('quick-order-list') || this.closest('quick-add-bulk');
    quickBulkElement.updateMultipleQty(items);
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;

    if (inputValue < event.target.dataset.min) {
      this.setValidity(event, index, window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min));
    } else if (inputValue > parseInt(event.target.max)) {
      this.setValidity(event, index, window.quickOrderListStrings.max_error.replace('[max]', event.target.max));
    } else if (inputValue % parseInt(event.target.step) != 0) {
      this.setValidity(event, index, window.quickOrderListStrings.step_error.replace('[step]', event.target.step));
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.startQueue(index, inputValue);
    }
  }

  getSectionsUrl() {
    if (window.pageNumber) {
      return `${window.location.pathname}?page=${window.pageNumber}`;
    } else {
      return `${window.location.pathname}`;
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
}

if (!customElements.get('bulk-add')) {
  customElements.define('bulk-add', BulkAdd);
}

// =====================================================================================
// LEGACY CART DRAWER IMPLEMENTATION - DEPRECATED 
// =====================================================================================
// This is the old implementation using direct AJAX calls and DOM manipulation
// Keeping this commented for reference purposes only
// Please use the new Section API implementation below for all new development
// =====================================================================================

// LEGACY - Original updateCartDrawer function (deprecated)
// function updateCartDrawer(){
//   fetch('/?section=qft-cart-drawer').then(response => response.text()).then((response)=>{
//     let parser = new DOMParser();
//     let doc = parser.parseFromString(response, 'text/html');
//     document.querySelector('.cart-btn').dataset.quantity = doc.getElementById('cart-overlay').dataset.quan;
//     const newDrawer = doc.getElementById('cart-drawer');
//     $('#cart-overlay').html("");
//     $('#cart-overlay').append(newDrawer);
//     let newScript = document.createElement('script');
//     newScript.src = $('#cart-overlay').data('src');
//     $('#cart-overlay').append(newScript);
//     $('#cart-overlay').css({ position: 'fixed', top: 0, bottom: 0, left: 0, right: 0, display: 'block' });
//     $('#cart-drawer').toggleClass('active');
//   });
// }

// LEGACY CART FUNCTIONS - COMMENTED OUT FOR REFERENCE ONLY
// These functions are deprecated and should not be used for new development
// 
// document.querySelectorAll('.cart-btn').forEach(button => {
//   button.addEventListener('click', function (el) {
//     el.preventDefault();
//     openCartDrawer();
//   });
// });title_wrapper-
// document.querySelectorAll('.cart-close').forEach(button => {
//   button.addEventListener('click', function () {
//     closeCartDrawer();
//   });
// });
// function openCartDrawer() {
//   $('#cart-overlay').css({ position: 'fixed', top: 0, bottom: 0, left: 0, right: 0, display: 'block' });
//   $('#cart-drawer').toggleClass('active');
//   $('.sticky_product_bar_wrap').slideUp();
//   updateCart();
// }
// function closeCartDrawer() {
//   $('#cart-overlay').css('position', 'unset');
//   $('#cart-drawer').removeClass('active');
// }
// function updateQuantity(quantity, prdct_key, target_el) {
//   fetch('/cart/change.js', {
//     method: 'POST',
//     headers: {
//       'Content-Type': 'application/json',
//     },
//     body: JSON.stringify({
//       quantity: quantity,
//       id: prdct_key,
//     }),
//   })
//     .then(response => response.json())
//     .then(data => {
//       if (data.status == 422)
//         alert(data.message);
//       else {
//         if(target_el != undefined){
//           if (target_el.classList.contains('quantity_num')) {
//             target_el.setAttribute('qft-qun-itm', data.item_count);
//             target_el.innerHTML = data.item_count;
//           }
//         }
//         updateCart();
//       }
//     })
//     .catch(error => {
//       console.error('Error updating cart:', error);
//     });
// }
// 
// function updateCart() {
//   fetch('/cart.js', {
//     method: 'GET',
//     headers: {
//       'Content-Type': 'application/json',
//     },
//   })
//     .then(response => response.json())
//     .then(data => {
//       if(data.item_count < 1){
//         $('.cart_empty').css('display','block');
//         $('[data-cart-item-wrap]').css('display','none');
//       }else{
//         $('.cart_empty').css('display','none');
//         $('[data-cart-item-wrap]').css('display','flex');
//         $('[data-item-wrap]').html('');
//         data.items.forEach((el, count) => {
//           let abc = JSON.stringify(el.variant.compare_at_price );
//           // console.error(el.selling_plan_allocation); 
//           console.log(abc);
//           $('[data-item-wrap]').append(`
//                   <div class="qft-card-item" qft-item>
//                     <a href="${el.url}"><img src="${el.featured_image.url}" alt="${el.featured_image.alt}" width="120px" height=""></a>
//                     <div style="width: 100%; display: flex; flex-direction: column;  justify-content: space-evenly">
//                       <a href="${el.url}" class="product-txt" style="font: 600 15px var(--font-body-family);margin-bottom:10px;">${el.title.split('-')[0]}</a>
//                       <div class="itm_btm_wrap">
//                         <div qft-quantity-wrap>
//                           <button class="qun_btn qun_minus" qft-qun-tgr><svg aria-hidden="true" width="12" height="2" viewBox="0 0 12 2" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1H11" stroke="#171717" stroke-width="1" stroke-linecap="round"></path></svg></button>
//                           <span class="quantity_num" qft-itm-key="${el.key}" qft-qun-itm="${el.quantity}">${el.quantity}</span>
//                           <button class="qun_btn qun_plus" qft-qun-tgr>
//                           <svg width="12" aria-hidden="true" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 6H11" stroke="#171717" stroke-width="1" stroke-linecap="round"></path><path d="M6 11L6 1" stroke="#171717" stroke-width="1" stroke-linecap="round"></path></svg></button>
//                         </div>
//                       </div>
//                     </div>
//                     <div style="color: #171717; ">
//                       <span class="money" style="font-size: 15px; text-wrap: nowrap;">${Shopify.formatMoney(el.final_price)}</span>
//                       <span class="compare_at_price" style="font-size: 12px; text-wrap: nowrap;">${Shopify.formatMoney(el.compare_at_price)}</span>
//                     </div>
//                   </div>
//                 `);
//           $('[qft-bag-ttl]').html(`Bag Total ${Shopify.formatMoney(data.original_total_price)}`);
//           $('[qft-bag-dis]').html(`Bag Discount ${Shopify.formatMoney(data.total_discount)}`);
//           $('[qft-bag-fnl]').html(`Total amount ${Shopify.formatMoney(data.total_price)}`);
//           $('.cart-btn').attr('data-quantity',data.item_count);
//         });
//       }
//       let newScript = document.createElement('script');
//       newScript.src = $('#cart-overlay').data('src');
//       $('#cart-overlay').append(newScript);
//     })
//     .catch(error => {
//       console.error('Error updating cart:', error);
//     });
// }

// =====================================================================================
// NEW SECTION API IMPLEMENTATION - STARTS HERE
// =====================================================================================
// This is the new implementation using Shopify's Section API
// Created by Claude Code Assistant - All new cart drawer functionality below
// =====================================================================================

/**
 * NEW SECTION-BASED CART DRAWER IMPLEMENTATION
 * Uses Shopify's Section API for better performance and easier price fetching
 */
class QFTCartDrawerSectionAPI {
  constructor() {
    this.cache = new Map();
    this.isInitialized = false;
    this.init();
  }

  init() {
    if (this.isInitialized) return;
    
    // Initialize cart button listeners
    this.bindCartEvents();
    this.isInitialized = true;
    console.log('QFT Cart Drawer Section API initialized');
  }

  bindCartEvents() {
    // Cart open buttons
    document.querySelectorAll('.cart-btn').forEach(button => {
      button.addEventListener('click', (el) => {
        el.preventDefault();
        this.openCartDrawer();
      });
    });

    // Cart close buttons
    document.querySelectorAll('.cart-close').forEach(button => {
      button.addEventListener('click', () => {
        this.closeCartDrawer();
      });
    });
  }

  async openCartDrawer() {
    $('#cart-overlay').css({ 
      position: 'fixed', 
      top: 0, 
      bottom: 0, 
      left: 0, 
      right: 0, 
      display: 'block' 
    });
    $('#cart-drawer').toggleClass('active');
    $('.sticky_product_bar_wrap').slideUp();
    $('body').addClass('overflow-hidden');
    
    // Use new section API method
    await this.updateCartWithSectionAPI();
    
    // FBT will load intelligently when reinitializeCartDrawerEvents is called
  }

  closeCartDrawer() {
    $('#cart-overlay').css('position', 'unset');
    $('#cart-drawer').removeClass('active');
    $('body').removeClass('overflow-hidden');
  }

  /**
   * OPTIMIZED METHOD: Update entire cart using single Section API call
   * Fetches complete cart drawer with all pricing and discount calculations server-side
   */
  async updateCartWithSectionAPI() {
    try {
      // Preserve current reserv_text before update (the div with background: #ebdbcb)
      const currentReservText = document.querySelector('#cart-drawer div[style*="background: #ebdbcb"]');
      const preservedReservTextHTML = currentReservText ? currentReservText.outerHTML : null;
      
      // Single Section API call to get complete cart drawer
      const response = await fetch('/?section_id=qft-cart-drawer', {
        method: 'GET',
        headers: { 'Content-Type': 'text/html' }
      });

      if (!response.ok) {
        throw new Error(`Section API request failed: ${response.status}`);
      }

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      // Extract the cart drawer content
      const newCartDrawer = doc.getElementById('cart-drawer');
      const newOverlayData = doc.getElementById('cart-overlay');
      
      if (!newCartDrawer || !newOverlayData) {
        throw new Error('Cart drawer elements not found in section response');
      }

      // Update cart quantity attribute on cart buttons
      const newQuantity = newOverlayData.dataset.quan;
      document.querySelectorAll('.cart-btn').forEach(btn => {
        btn.setAttribute('data-quantity', newQuantity);
      });

      // Replace entire cart drawer content while preserving the overlay structure
      const currentCartDrawer = document.getElementById('cart-drawer');
      if (currentCartDrawer) {
        currentCartDrawer.innerHTML = newCartDrawer.innerHTML;
        
        // Restore the preserved reserv_text if it existed
        if (preservedReservTextHTML) {
          const newReservTextElement = currentCartDrawer.querySelector('div[style*="background: #ebdbcb"]');
          if (newReservTextElement) {
            newReservTextElement.outerHTML = preservedReservTextHTML;
          }
        }
      }

      // Reinitialize cart drawer script if needed
      this.reinitializeCartDrawerEvents();
      initializeSwiper();

      console.log('✅ Cart drawer updated successfully with Section API');

    } catch (error) {
      console.error('❌ Error updating cart with Section API:', error);
      // Fallback to legacy method if section API fails
      await this.fallbackToLegacyUpdate();
    }
  }


  /**
   * OPTIMIZED METHOD: Update cart quantities with single section refresh
   */
  async updateQuantity(quantity, productKey, targetEl) {
    try {
      // Validate quantity
      if (quantity < 0) quantity = 0;

      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          quantity: quantity,
          id: productKey,
        }),
      });
      
      const data = await response.json();
      
      if (data.status == 422) {
        alert(data.message);
        return;
      }

      // Single section refresh instead of individual item updates
      await this.updateCartWithSectionAPI();
      
      console.log(`✅ Cart quantity updated: ${productKey} -> ${quantity}`);

    } catch (error) {
      console.error('❌ Error updating cart quantity:', error);
      // Show user-friendly error
      alert('Failed to update cart. Please try again.');
    }
  }

  /**
   * NEW METHOD: Remove item from cart
   */
  async removeItem(productKey) {
    try {
      await this.updateQuantity(0, productKey);
    } catch (error) {
      console.error('❌ Error removing cart item:', error);
    }
  }
  // async removeItem(productKey) {
  //   try {
  //     await updateQuantity(0, productKey);
  //     const response = await fetch(window.location.pathname + '?sections=qft-cart');
  //     const result = await response.json();
  //     document.querySelector('[id="qft_cart_items"]').innerHTML = result['qft-cart'];
  //   } catch (error) {
  //     console.error('❌ Error:', error);
  //   }
  // }

  /**
   * NEW METHOD: Reinitialize cart drawer events after content update
   */
  reinitializeCartDrawerEvents() {
    // Reinitialize close button events
    document.querySelectorAll('.cart-close').forEach(button => {
      button.removeEventListener('click', this.closeCartDrawer);
      button.addEventListener('click', () => {
        this.closeCartDrawer();
      });
    });

    // Reinitialize jQuery events from qft-cart-drawer.js
    // Remove existing jQuery event handlers
    $('[qft-product-remove]').off('click');
    $('.qun_btn').off('click');

    // Reattach jQuery event handlers
    $('[qft-product-remove]').on('click', (el) => {
      let prdctKey = parseInt($(el.currentTarget).attr('qft-product-remove'));
      jQuery.post('/cart/change.js', { quantity: 0, id: prdctKey }).then(() => { updateCart(); });
    });

    $('.qun_btn').on('click', (el) => {
      let input_el = el.currentTarget.parentElement.children[1];
      let quantity = input_el.getAttribute('qft-qun-itm');
      let prdct_key = input_el.getAttribute('qft-itm-key');
      if (el.currentTarget.classList.contains('qun_plus'))
        quantity++;
      else if (el.currentTarget.classList.contains('qun_minus')) {
        quantity--;
      }
      updateQuantity(quantity, prdct_key, input_el);
    });

    // Reinitialize FBT section if it exists
    if (document.querySelector('.frequently-bought-together')) {
      console.log('🔄 Reinitializing FBT after cart update');
      // Re-initialize the FBT functionality after cart content update
      setTimeout(() => {
        // Create new FBT instance since cart content was replaced
        if (window.fbtInstance) {
          // Cleanup existing instance
          window.fbtInstance = null;
        }
        // Create new instance - check if ShopifyFBTCartDrawer class is available
        if (typeof ShopifyFBTCartDrawer !== 'undefined') {
          window.fbtInstance = new ShopifyFBTCartDrawer();
          console.log('✅ New FBT instance created after cart update');
          
          // Load recommendations if drawer is currently active
          if ($('#cart-drawer').hasClass('active')) {
            setTimeout(() => {
              if (window.fbtInstance && typeof window.fbtInstance.loadRecommendationsIfNeeded === 'function') {
                window.fbtInstance.loadRecommendationsIfNeeded();
              }
            }, 100);
          }
        } else {
          console.warn('⚠️ ShopifyFBTCartDrawer class not available for reinitialization');
        }
      }, 150); // Delay to ensure DOM is updated
    }

    console.log('🔄 Cart drawer events reinitialized');
  }

  /**
   * FALLBACK METHOD: Legacy cart update for error recovery
   */
  async fallbackToLegacyUpdate() {
    try {
      console.log('🔄 Using fallback legacy cart update method');
      
      const cartResponse = await fetch('/cart.js', {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      });
      const cartData = await cartResponse.json();

      if (cartData.item_count < 1) {
        $('.cart_empty').css('display', 'block');
        $('[data-cart-item-wrap]').css('display', 'none');
        return;
      }

      $('.cart_empty').css('display', 'none');
      $('[data-cart-item-wrap]').css('display', 'flex');
      
      // Update cart button quantity
      $('.cart-btn').attr('data-quantity', cartData.item_count);
      
      console.log('✅ Fallback cart update completed');

    } catch (error) {
      console.error('❌ Fallback cart update also failed:', error);
    }
  }

}

// Initialize the new cart drawer system
window.qftCartDrawer = new QFTCartDrawerSectionAPI();

// Ensure initialization is complete before setting up backward compatibility
setTimeout(() => {
  console.log('🔄 QFT Cart Drawer Section API initialization complete');
}, 100);

// =====================================================================================
// BACKWARD COMPATIBILITY BRIDGE FUNCTIONS
// =====================================================================================
// These functions provide backward compatibility for existing code that calls
// the old function names. They bridge to the new Section API implementation.
// =====================================================================================

/**
 * BACKWARD COMPATIBILITY: openCartDrawer()
 * Bridges old function calls to new Section API implementation
 */
function openCartDrawer() {
  console.log('🔄 Legacy openCartDrawer() called - bridging to new Section API implementation');
  if (window.qftCartDrawer && typeof window.qftCartDrawer.openCartDrawer === 'function') {
    return window.qftCartDrawer.openCartDrawer();
  } else {
    console.error('❌ QFT Cart Drawer Section API not initialized');
  }
}

/**
 * BACKWARD COMPATIBILITY: closeCartDrawer()
 * Bridges old function calls to new Section API implementation
 */
function closeCartDrawer() {
  console.log('🔄 Legacy closeCartDrawer() called - bridging to new Section API implementation');
  if (window.qftCartDrawer && typeof window.qftCartDrawer.closeCartDrawer === 'function') {
    return window.qftCartDrawer.closeCartDrawer();
  } else {
    console.error('❌ QFT Cart Drawer Section API not initialized');
  }
}

/**
 * BACKWARD COMPATIBILITY: updateCart()
 * Bridges old function calls to new Section API implementation
 */
function updateCart() {
  console.log('🔄 Legacy updateCart() called - bridging to new Section API implementation');
  if (window.qftCartDrawer && typeof window.qftCartDrawer.updateCartWithSectionAPI === 'function') {
    return window.qftCartDrawer.updateCartWithSectionAPI();
  } else {
    console.error('❌ QFT Cart Drawer Section API not initialized');
  }
}

/**
 * BACKWARD COMPATIBILITY: updateQuantity()
 * Bridges old function calls to new Section API implementation
 */
function updateQuantity(quantity, productKey, targetEl) {
  console.log('🔄 Legacy updateQuantity() called - bridging to new Section API implementation');
  if (window.qftCartDrawer && typeof window.qftCartDrawer.updateQuantity === 'function') {
    return window.qftCartDrawer.updateQuantity(quantity, productKey, targetEl);
  } else {
    console.error('❌ QFT Cart Drawer Section API not initialized');
  }
}

// Make functions available globally for backward compatibility
window.openCartDrawer = openCartDrawer;
window.closeCartDrawer = closeCartDrawer;
window.updateCart = updateCart;
window.updateQuantity = updateQuantity;

console.log('✅ Backward compatibility bridge functions initialized');

// =====================================================================================
// END OF BACKWARD COMPATIBILITY BRIDGE
// =====================================================================================

// =====================================================================================
// END OF NEW SECTION API IMPLEMENTATION
// =====================================================================================

// This function is used to initialize swiper for the static recommendations on cart drawer
// comment this if the static recommendations are reverted.

 function initializeSwiper() {
    // Cleanup existing swiper first
    if (window.fbtSwiper) {
      try {
        window.fbtSwiper.destroy(true, true);
        window.fbtSwiper = null;
      } catch (e) {
        console.warn('Failed to destroy existing FBT swiper:', e);
      }
    }

    if (typeof Swiper === 'undefined') {
      if (!document.querySelector('link[href*="swiper"]')) {
        const swiperCSS = document.createElement('link');
        swiperCSS.rel = 'stylesheet';
        swiperCSS.href = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
        document.head.appendChild(swiperCSS);
      }

      if (!document.querySelector('script[src*="swiper"]')) {
        const swiperJS = document.createElement('script');
        swiperJS.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
        swiperJS.onload = () => this.initializeSwiper();
        document.head.appendChild(swiperJS);
        return;
      }
    }

    // Find the FBT swiper container within this cart drawer
    const swiperContainer = document.querySelector('.fbt-swiper');
    if (!swiperContainer) {
      console.warn('⚠️ FBT swiper container not found');
      return;
    }

   
    window.fbtSwiper = new Swiper(swiperContainer, {
      slidesPerView: 1,
      spaceBetween: 12,
      navigation: {
        nextEl: '.fbt-swiper-button-next',
        prevEl: '.fbt-swiper-button-prev',
      },
      grabCursor: true,
      loop: false,
    });

    console.log('🎠 Swiper initialized for FBT');
  }